import { alpha, css } from '@mui/material/styles';
export const switchComponentOverrides = {
    MuiSwitch: {
        defaultProps: {
            size: 'medium',
            color: 'primary',
            disableFocusRipple: true,
            disableRipple: true,
            disableTouchRipple: true
        },
        styleOverrides: {
            root: ({ theme }) => css `
                width: 40px;
                height: 20px;
                border-radius: 100px;
                margin: 8px 8px 8px 11px;
                overflow: visible;
                padding: 0;

                &:has(.Mui-disabled) {
                    opacity: 0.4;
                }

                & .MuiSwitch-track {
                    width: inherit;
                    height: inherit;
                    border-radius: 100px;
                    position: relative;
                    opacity: 1 !important;
                    background-color: ${theme.tokens.FuelColorGray600};

                    &:before, &:after {
                        opacity: 1;
                        display: block;
                        position: absolute;
                        top: 3px;
                        height: 14px;
                        width: 14px;
                        margin-inline: 0;
                        content: '';
                        background-position: center;
                    }

                    &:before {
                        background-image: url("data:image/svg+xml,%3Csvg focusable='false' aria-hidden='true' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23FFFFFF'%3E%3Cpath d='M0 0h24v24H0z' fill='none'%3E%3C/path%3E%3Cpath d='M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z'%3E%3C/path%3E%3C/svg%3E");
                        left: 3px;
                    }

                    &:after {
                        background-image: url("data:image/svg+xml,%3Csvg focusable='false' aria-hidden='true' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23FFFFFF'%3E%3Cpath d='M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'%3E%3C/path%3E%3Cpath d='M0 0h24v24H0z' fill='none'%3E%3C/path%3E%3C/svg%3E");
                        right: 3px;
                    }
                }

                & .MuiSwitch-switchBase {
                    width: 14px;
                    height: 14px;
                    position: absolute;
                    top: 3px;
                    left: 3px;
                    box-sizing: content-box;
                    box-shadow: ${alpha(theme.tokens.FuelColorBlack, 0.25)} 0px 1px 2px;
                    padding: 0;
                    background-color: ${theme.tokens.FuelColorBackgroundWhite};

                    &[data-fuel-hide-icons=true] {
                        & + .MuiSwitch-track {
                            &:before, &:after {
                                display: none;
                            }
                        }
                    }

                    &[data-fuel-hide-on-icon=true] {
                        & + .MuiSwitch-track {
                            &:before {
                                display: none;
                            }
                        }
                    }

                    &[data-fuel-hide-off-icon=true] {
                        & + .MuiSwitch-track {
                            &:after {
                                display: none;
                            }
                        }
                    }

                    &.Mui-checked {
                        left: 23px;
                        transform: none;

                        & + .MuiSwitch-track {
                            background-color: ${theme.tokens.FuelColorBrandPrimary};
                        }

                        &:hover {
                            background-color: ${theme.tokens.FuelColorBackgroundWhite};
                        }

                        &.Mui-focusVisible:before {
                            right: -3px;
                            left: auto;
                        }
                    }

                    &.Mui-focusVisible {
                        transition: none;
                    }

                    &.Mui-focusVisible:before {
                        width: 2.5rem;
                        height: 1.25rem;
                        content: '';
                        display: block;
                        padding: 0;
                        position: absolute;
                        box-shadow: 0 0 0 0.125rem #ffffff, 0 0 0 0.25rem #1b1b1b;
                        border-radius: 9999px;
                        left: -0.1875rem;
                        top: -0.1875rem;
                    }

                    &:hover {
                        background-color: ${theme.tokens.FuelColorBackgroundWhite};
                    }

                    &.Mui-disabled {
                        color: unset;
                    }
                }

                & .MuiSwitch-thumb {
                    display: none;
                }

                & .MuiSwitch-input {
                    top: 50%;
                    transform: translateY(-50%);
                    width: 400%;
                    height: 200%;
                }
            `
        }
    }
};
